<template>
  <div>
    <!-- BEGIN panel -->
    <div class="card border-0 mb-3">
      <JobPanel :job="task"> </JobPanel>
      <div class="card-footer fs-26px cursor-pointer">
        <div class="d-flex justify-content-center">
          <div class="text-success pe-3" v-b-tooltip.hover title="Выполнено">
            {{ task.done }}
          </div>
          <div class="pe-3" v-b-tooltip.hover title="На проверке">0</div>
          <div class="text-danger pe-3" v-b-tooltip.hover title="Количество обращений в арбитраж исполнителями">
            0
          </div>
        </div>
      </div>
    </div>


    <b-tabs nav-wrapper-class="nav nav-tabs" content-class="panel mb-0 p-3 rounded-0">
      <!-- BEGIN tab -->
      <b-tab active>
        <template slot="title">
          <span class="d-sm-none">Описание</span>
          <span class="d-sm-block d-none">Описание</span>
        </template>

        <!-- BEGIN #accordion -->
        <div id="accordion" class="accordion rounded-top overflow-hidden">
          <!-- BEGIN b-card -->
          <h3>Описание задачи:</h3>
          <div class="pre-formatted">
            {{ task.description }}
          </div>

          <h3 class="pt-4">Подтверждение и проверка выполнения:</h3>
          <div class="pre-formatted">
            {{ task.check }}
          </div>

          <h5 v-show="task.img_cnt" class="pt-5">
            Минимальное количество скриншотов в отчете: {{ task.img_cnt }}
          </h5>

          <h3 class="pt-4">Ссылка для выполнения задания:</h3>
          <i>Для выполнения задания перейдите по следующей ссылке:</i><br />
          <a :href="task.link" target="_blank">{{ task.link }}</a><br />

          <div v-if="!jobs" class="d-flex justify-content-center">
            <div class="btn btn-info mt-4" @click="$bvModal.show('modalDialog')">
              Выполнить задание
            </div>

          </div>
          <!-- END b-card -->
        </div>
        <!-- END #accordion -->
      </b-tab>
      <!-- END tab -->
    </b-tabs>

    <!-- END panel -->

    <JobChat :task="task" :job="jobs"></JobChat>

    <!-- BEGIN #modal-dialog -->
    <b-modal id="modalDialog" cancel-variant="default" centered>
      <template slot="modal-header">
        <h4 class="modal-title">Подтверждение:</h4>
        <a class="btn-close" @click="$bvModal.hide('modalDialog')"></a>
      </template>
      <p class="text-center pt-3">Вы дожны выполнить это задание в течение: <b>{{ task.time_work_desc }}</b></p>
      <p class="text-center" v-if="task.img_cnt">В вашем отчете должно быть скриншотов минимум: <b>{{
        task.img_cnt
      }}</b></p>
      <p class="text-center">Автор проверит задание в течение: <b>{{ task.time_check_desc }}</b></p>
      <p class="text-center">На время выполнения мы зарезирвируем: <b>{{ task.price }} руб.</b><br> Вы получите эту сумму после выполнения задания.</p>
      <template #modal-footer>
        <div>
          <b-button variant="white" size="sm" class="float-right me-2" @click="$bvModal.hide('modalDialog')">
            Отмена
          </b-button>
          <b-button variant="primary" size="sm" class="float-right" @click="jobCreate() || $bvModal.hide('modalDialog')">
            Начать выполнение
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- END #modal-dialog -->
  </div>
</template>

<script>
import HTTP from "../http";
import {show_error} from "../message";

export default {
  data() {
    return {
      id: 0,
      loading: false,
      task: {},
      jobs: null,
      message: "",
      status: "REVIEW",
    };
  },

  created() {
    this.id = this.$route.params.id;
    window.eventBus.$on("user.chat.update", () => {
      this.fetchData();
    });
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .get(`/job/${this.id}`)
        .then((resp) => {
          console.log("resp", resp);
          this.task = resp.data.task;
          this.jobs = resp.data.jobs;
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data);
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },

    jobCreate() {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .post(`/job`, {task_id: this.id})
        .then((resp) => {
          console.log("resp", resp);
          this.message = "";
          this.fetchData();
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data);
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
  },
};
</script>

<style>
.task-href {
  cursor: pointer;
  text-decoration: none;
  color: var(--bs-body-color);
}

.task-href:visited {
  color: var(--bs-body-color);
}

.task-href:hover {
  color: var(--bs-body-color);
}

.pre-formatted {
  white-space: pre-wrap;
}
</style>
